<template>
  <div class="step-want">
    <h2>What do you usually want most from astrology-based answers?</h2>
    <div class="options">
      <button v-for="opt in options" :key="opt" class="option-btn" :class="{ active: want === opt }" @click="want = opt">
        {{ opt }}
      </button>
    </div>
    <button class="primary-btn" :disabled="!want" @click="$emit('next', want)">Continue</button>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'StepWant',
  emits: ['next'],
  setup() {
    const want = ref('')
    const options = ['Clarity', 'Comfort', 'Direction', 'Validation', 'Curiosity']
    return { want, options }
  }
}
</script>

<style scoped>
.step-want { max-width: 520px; margin: 0 auto; padding: 20px; display: flex; flex-direction: column; align-items: center; gap: 36px; text-align: center; }
.step-want h2 { font-size: 24px; font-weight: 700; color: #fff; line-height: 1.3; }
.options { display: flex; flex-direction: column; gap: 12px; width: 100%; }
.option-btn { padding: 16px 24px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); border-radius: 12px; color: #fff; font-size: 16px; font-weight: 500; cursor: pointer; transition: all 0.2s; text-align: left; font-family: inherit; }
.option-btn:hover { background: rgba(255,255,255,0.08); }
.option-btn.active { background: rgba(108,99,255,0.12); border-color: #6c5ce7; }
.primary-btn { padding: 16px 24px; background: #6c5ce7; border: none; border-radius: 12px; color: #fff; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; width: 100%; }
.primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.primary-btn:hover { background: #7c6ff0; box-shadow: 0 6px 20px rgba(108,99,255,0.35); }
</style>
